import { createIdAction, createTimestampedAction, props } from '@app/helpers';

enum Action {
  HIDE_PREVIEW = '[Preview Popover] Hide Preview',
  SHOW_DETAIL = '[Preview Popover] Show Detail',
}

export const hidePreview = createTimestampedAction(Action.HIDE_PREVIEW);
export const showDetail = createIdAction(Action.SHOW_DETAIL);
